/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["star-rating-widget{display:flex;align-items:center;color:rgba(0,0,0,.7)}star-rating-widget .stars{padding-right:5px}star-rating-widget .current-rating{min-width:30px;line-height:40px;font-size:1.8rem;font-weight:500;text-align:center;border-left:1px solid var(--be-divider-default);padding-left:10px}"];
export { styles as styles };
